/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'underscore',
	'../../../lib/@waca/upgrades/UpgradeBase',
	'./utils/WidgetUpgradeUtils'
], (_, UpgradeBase, WidgetUpgradeUtils) => {

	/**
	* Bar based chart types before R7 ignored the valueAxis.zeroOrigin property
	* To avoid upgraded charts looking different we want to ensure that if a
	* vis had this property set previously (say it was a line chart, the prop was
	* changed and then the vis was changed to a bar chart and saved) then we have
	* to set the prop to true for these chart types.
	**/

	class ColBarZeroOriginValueUpgrade extends UpgradeBase {

		constructor() {
			super();

			this.VERSION = 1801;
		}

		/**
		 * Perform upgrade
		 *
		 * @param {object} spec - spec to perform upgrade on
		 *
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up(spec) {
			if (!spec) {
				return Promise.resolve(spec);
			}
			if (!WidgetUpgradeUtils.specHasWidgets(spec)) {
				return Promise.resolve(spec);
			}

			/*
			* Cycle through all widgets and, if they are live widgets, upgrade the property.
			*/
			_.each(spec.widgets, model => {
				if (model && WidgetUpgradeUtils.isLiveWidgetModel(model)) {
					if (!model.properties) {
						model.properties = [];
					}
					this._colBarZeroOriginValueUpgrade(model);
				}
			});
			return Promise.resolve(spec);
		}

		// Downgrades are not available in CA
		down(spec) {
			return Promise.resolve(spec);
		}

		_colBarZeroOriginValueUpgrade(model) {
			const needsUpgradeVisIds = [
				'com.ibm.vis.rave2bundlebar',
				'com.ibm.vis.rave2bundlecolumn',
				'com.ibm.vis.rave2bundlestackedbar',
				'com.ibm.vis.rave2bundlestackedcolumn'
			];
			if (_.contains(needsUpgradeVisIds, model.visId)) {
				const zeroOriginPropId = 'valueAxis.zeroOrigin';
				let zeroOriginProp = WidgetUpgradeUtils.findProperty(zeroOriginPropId, model.properties);
				if (zeroOriginProp) {
					zeroOriginProp.value = true;
				}
			}
		}

	}

	return new ColBarZeroOriginValueUpgrade();
});
